import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SuggestedProductView from './SuggestedProductView';

export default class SuggestedProductsView extends Component {
    render() {
        const products = this.props.products;
        return (<div className="suggestedProductsReactComponent">
            {this.props.headerText &&
            <div className="suggested-products-main-label"><span>{this.props.headerText}</span></div>
            }
            <div>
                {products.length === 0 ? 'No suggested products found.' : null}
                {products.map((product) =>
                    <SuggestedProductView
                        key={product.id}
                        product={product}
                        productCount={this.props.productCountOverride || products.length}/>
                )}
            </div>
        </div>);
    }

    static propTypes = {
        products: PropTypes.array.isRequired,
        headerText: PropTypes.string,
        productCountOverride: PropTypes.number,
    };
}
